<template>
<div class="content">
  <!-- Move to wallet modal  -->
  <md-dialog :md-active.sync="showDialog">
    <md-dialog-title>Do you want to proceed?</md-dialog-title>
    <md-dialog-content>Are you sure?</md-dialog-content>
    <md-dialog-actions>
      <md-button
          class="md-success"
          @click="confirmed()"
      >YES</md-button
      >
      <md-button class="md-danger" @click="close">NO</md-button>
    </md-dialog-actions>
  </md-dialog>
</div>
</template>

<script>
export default {
  name: 'Confirmation',
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    confirmed() {
      this.$emit('confirmed');
      this.close();
    },
  },
};
</script>

<style scoped>

</style>
